'use client'

import { FC } from 'react'
import { useGetTranslations } from '@/root/shared-hooks'
import { Gender } from '@/root/shared-providers/BookingCart/types'
import cn from 'classnames'

interface GenderToggleProps {
  onChange: (value: Gender) => void
  disabled: boolean
  value?: Gender
}

export const GenderToggle: FC<GenderToggleProps> = ({ value, onChange, disabled = false }) => {
  const isMale = value === 'M'
  const isFemale = value === 'F'
  const isUnset = !isMale && !isFemale

  const { getTranslation } = useGetTranslations()

  const handleChange = (gender: Gender) => {
    if (disabled) return
    onChange(gender)
  }

  return (
    <div
      className={cn(
        'border-neutral-medium-lighter relative inline-flex w-fit rounded-lg border bg-white text-lg uppercase',
        disabled && 'opacity-50'
      )}
    >
      {/* Sliding indicator */}
      <div
        className={cn(
          'absolute inset-y-0 rounded-lg transition-all duration-300 ease-in-out',
          isUnset ? 'left-1/4 w-1/2 bg-white' : 'bg-interactive w-1/2',
          isMale ? 'left-0' : isFemale ? 'left-1/2' : ''
        )}
      />

      {/* Male */}
      <button
        type="button"
        onClick={() => handleChange('M')}
        className={cn(
          'relative z-10 flex size-9 items-center justify-center rounded-lg',
          !disabled && 'cursor-pointer'
        )}
      >
        <span
          className={cn(
            'leading-none transition-colors duration-300',
            isMale ? 'text-white' : 'text-neutral-medium-lighter'
          )}
        >
          {getTranslation('selectTicketsGenderM')}
        </span>
      </button>

      {/* Female */}
      <button
        type="button"
        onClick={() => handleChange('F')}
        className={cn(
          'relative z-10 flex size-9 items-center justify-center rounded-lg',
          !disabled && 'cursor-pointer'
        )}
      >
        <span
          className={cn(
            'leading-none transition-colors duration-300',
            isFemale ? 'text-white' : 'text-neutral-medium-lighter'
          )}
        >
          {getTranslation('selectTicketsGenderF')}
        </span>
      </button>
    </div>
  )
}
